import { SEO } from "../components/site/SEO";
import { PageHeader } from "../components/site/primitives";
import { Enquiry } from "../components/site/Contact";

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Request a Selection — Contact Emporium London"
        description="Contact Emporium London to request a tailored selection and trade quote for your hotel, restaurant or corporate order. We reply to every trade enquiry within two working days."
        path="/contact"
      />
      <main>
        <PageHeader
          overline="Request a Selection"
          title="Contact us to build your order"
          intro="Tell us about your selection, volumes and theme. We reply to every trade enquiry within two working days with a tailored quote and samples."
        />
        <Enquiry />
      </main>
    </>
  );
}
